var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":_vm.cacheList,"exclude":_vm.notCacheName}},[_c('router-view',{ref:"child"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }